<template>
  <div id="app">
    <nav class="navbar is-background-light" role="navigation" aria-label="main navigation">
      <div class="navbar-brand">
        <a class="navbar-item" href="/">
          <p class="title is-4 logo Graphit-Bold">NEON/NOE</p>
        </a>

        <!-- <a role="button" class="navbar-burger" aria-label="menu" aria-expanded="false">
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
        </a> -->
      </div>
    </nav>

    <router-view></router-view>


  </div>
</template>


<script>

import { Snackbar } from 'buefy/dist/components/snackbar';
// @ is an alias to /src
export default {
  name: 'App',
  components: {
  },
  methods: {
  },
  created() {
    // `this` points to the vm instance
    // this.$snackbar.open('Default, positioned bottom-right with a green \'OK\' button');
    Snackbar.open({
      message: 'This website uses cookies.',
      type: 'is-warning',
      position: 'is-bottom-right',
      actionText: 'Accept',
      indefinite: true,
      onAction: () => {
        this.$toast.open({
          message: '👍 Thanks',
          queue: false,
          position: 'is-bottom-right',
        });
      },
    });
  },
};
</script>

<style scoped>
  .logo {
    padding-top: 60px;
    padding-left: 10px
  }
</style>
